import { render, staticRenderFns } from "./SearchableDropdown.vue?vue&type=template&id=5472d704&scoped=true"
import script from "./SearchableDropdown.vue?vue&type=script&lang=js"
export * from "./SearchableDropdown.vue?vue&type=script&lang=js"
import style0 from "./SearchableDropdown.vue?vue&type=style&index=0&id=5472d704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472d704",
  null
  
)

export default component.exports